export const SliderConfig = {
  dots: true,
  dotsClass: 'slick-dots container',
  autoplay: false,
  autoplaySpeed: 4000,
};
